import appConfig from '../../config';
import "select2/dist/js/i18n/cs";

export default class SelectComponent {
	constructor() {
		this.selector = 'select[data-provide="select"]:not([data-select-init="1"])';
		this.defaultConfig = {
			language: appConfig.locale,
			dropdownAutoWidth: true,
			minimumResultsForSearch: -1
		};
		this.init();
	}

	init() {
		const elements = document.querySelectorAll(this.selector);
		elements.forEach((item) => this.initializeSelect(item));
	}

	initializeSelect(item) {
		item.setAttribute('data-select-init', "1");

		const config = {...this.defaultConfig, ...this.getCustomConfig(item)};

		if (item.hasAttribute('multiple')) {
			$(item).select2(config)
				.on('select2:closing', (e) => this.handleSelectEvent(e));
		} else {
			$(item).select2(config)
				.on('select2:select', (e) => this.handleSelectEvent(e));
		}
	}

	getCustomConfig(item) {
		const customConfig = {};

		if (item.hasAttribute('multiple')) {
			customConfig.closeOnSelect = false;
			customConfig.width = 'auto';
		}

		if (item.getAttribute('placeholder')) {
			customConfig.placeholder = item.getAttribute('placeholder');
		} else if (item.getAttribute('data-none-selected-text')) {
			customConfig.placeholder = item.getAttribute('data-none-selected-text');
		}

		if (item.getAttribute('data-select-width')) {
			customConfig.width = item.getAttribute('data-select-width');
		}

		return customConfig;
	}

	handleSelectEvent(e) {
		const event = new Event('change', {bubbles: true, cancelable: true});
		Object.defineProperty(event, 'target', {writable: false, value: e.target});
		document.dispatchEvent(event);
	}
}
